import { FlagOutlined } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { Handle, Position } from "reactflow";
import FlowContext from "../../../contexts/flowContext";
import SidebarContext from "../../../contexts/sidebar";
import styles from "./node.module.css";

const Node = ({ data, id }) => {
  const [flowState, flowDispatcher] = useContext(FlowContext);
  const [, sidebarDispatcher] = useContext(SidebarContext);

  const [selected, setSelected] = useState(false);

  useEffect(() => {
    const selectedNode = flowState.nodes.filter(
      (node) => node.id === id && node.selected
    );
    setSelected(selectedNode.length && selectedNode[0].selected === true);
  }, [flowState.nodes]);

  const handleStartIconClick = function (e) {
    flowDispatcher({
      type: "set-start-node",
      id,
    });
  };

  const handleEditNodeButtonClick = function () {
    sidebarDispatcher({
      type: "open",
      value: true,
      manager: "node",
    });
    flowDispatcher({
      type: "unselect-all-edges",
    });
    flowDispatcher({
      type: "set-selected-node",
      node: flowState.nodes.filter((node) => node.id === id)[0],
    });
  };

  return (
    <div className={`${styles.node} ${selected ? styles.selected : ""}`}>
      {data.handles === 2 && <Handle type="target" position={Position.Top} />}
      <div
        className={`${styles.start_node} ${
          data.starter ? styles.start_node_enabled : styles.start_node_disabled
        }`}
        onClick={handleStartIconClick}
      >
        <FlagOutlined />
      </div>
      {!selected && (
        <div
          className={styles.edit_node_button}
          onClick={handleEditNodeButtonClick}
        >
          <AiOutlineEdit />
        </div>
      )}
      <h4>{data.name}</h4>
      <div>
        <span>
          Module: <strong>{data.module.options.type}</strong>
        </span>
      </div>
      <div className={styles.description}>
        <p>{data.module.options.description}</p>
      </div>
      <Handle type="source" position={Position.Bottom} id="a" />
    </div>
    /*<Card title="Card title">Card content</Card>*/
  );
};

export default Node;
